import React from 'react';
import __ from "../../../i18n";
import InlineEditor from "../inline-editor/InlineEditor";
import VideoHelper from "../../../helpers/VideoHelper";


function getColumnConfigs({updateItem, refreshData}) {
    return [
        {
            key: 'id',
            name: __('ID'),
            sortable: true
        },
        {
            key: '*video',
            name: __('Video'),
            sortable: false,
            renderValue: (_, item) => {
                return <video src={VideoHelper.getUrl(item)}/>;
            }
        },
        {
            key: 'title',
            name: __('Title'),
            sortable: true,
            renderEditor: (item, onSubmittingChange, close) => {
                return <InlineEditor
                    item={item}
                    updateItem={updateItem}
                    close={close}
                />;
            }
        },
        {
            key: 'mime_type',
            name: __('Mime type'),
            sortable: true
        },
        {
            key: 'extension',
            name: __('Extension'),
            sortable: true
        },
        {
            key: 'width',
            name: __('Width'),
            sortable: true
        },
        {
            key: 'height',
            name: __('Height'),
            sortable: true
        },
        {
            key: 'aspect_ratio',
            name: __('Aspect ratio'),
            sortable: true
        },
        {
            key: 'duration',
            name: __('Duration'),
            sortable: true
        },
    ];
}

export default {
    getColumnConfigs
};
